// Згенеровано Tools/gen_frontend.py з визначень модулів. Не редагувати вручну: зміни моделі — у визначенні модуля
// Solutions/Metadata/<Група>/<Модуль>/module.definition.json (каталог Design — похідний), власні подання — у views/ пакета.

import type { IRecordTypeDefinition } from '@platform/core/types';
import { assembleViewSet } from '@platform/core/lib/assembleViewSet';
import kbEntity from './entities/kb.json';
import kbMenu from '../pages/kb/menu.json';
import kbFullForm from '../pages/kb/forms/full.json';
import kbContextForm from '../pages/kb/forms/context.json';
import kbMiniForm from '../pages/kb/forms/mini.json';
import kbLookupForm from '../pages/kb/forms/lookup.json';
import kbTableView from '../pages/kb/views/table.json';
import kbStagesView from '../pages/kb/views/stages.json';
import kbCardsView from '../pages/kb/views/cards.json';
import kbSplitView from '../pages/kb/views/split.json';
import kbCalendarView from '../pages/kb/views/calendar.json';
import kbDashboardView from '../pages/kb/views/dashboard.json';
import kbLibraryView from '../pages/kb/views/library.json';

/** Тип запису «Стаття» зі сторінками пакета: меню, форми та подання з pages/kb/. */
export const kbDefinition: IRecordTypeDefinition = {
  ...kbEntity,
  views: assembleViewSet({
      table: kbTableView,
      stages: kbStagesView,
      cards: kbCardsView,
      split: kbSplitView,
      calendar: kbCalendarView,
      dashboard: kbDashboardView,
      library: kbLibraryView,
  }),
  form: kbFullForm,
  forms: { full: kbFullForm, context: kbContextForm, mini: kbMiniForm, lookup: kbLookupForm },
  menu: kbMenu,
} as IRecordTypeDefinition;
